import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { AuthCheckpoint } from "@/core/services/api/interfaces/admin/AuthCheckpoint";

class AuthCheckpointsEndpoint {
  public list(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("a/auth-checkpoints", params);
  }

  public toggleStatus(authCheckpoint: AuthCheckpoint): Promise<AxiosResponse> {
    return $api.put(`a/auth-checkpoints/${authCheckpoint.id}/status`);
  }
}

export default AuthCheckpointsEndpoint;
